import { render, staticRenderFns } from "./MainTowerCard.vue?vue&type=template&id=bc7da8ea&scoped=true&"
import script from "./MainTowerCard.vue?vue&type=script&lang=js&"
export * from "./MainTowerCard.vue?vue&type=script&lang=js&"
import style0 from "./MainTowerCard.vue?vue&type=style&index=0&id=bc7da8ea&lang=less&scoped=true&"
import style1 from "./MainTowerCard.vue?vue&type=style&index=1&id=bc7da8ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7da8ea",
  null
  
)

export default component.exports